export function logError(...data: any[]) {
  console.error('%c Error! ', 'background: #ff0000; color: #bada55', ...data);
}
